import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

import printProductBaseDetails from '../fragments/printProductBaseDetails';

export const getGlobalPrintCategoriesQuery = gql`
  query getGlobalPrintCategoriesQuery {
    printCategories(global_only: true) {
      total
      records {
        id
        name
        asset_image {
          id
          url
          width
          height
        }
        print_products {
          total
          records {
            ...printProductBaseDetails
          }
        }
      }
    }
  }
  ${printProductBaseDetails}
`;

const getGlobalPrintCategories = graphql(getGlobalPrintCategoriesQuery);

export default getGlobalPrintCategories;
